<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="50px" size="mini">
					<el-form-item label="类型">
						<el-select size="small" v-model="form.type" placeholder="" @change="change">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="名称" required>
						<el-input v-model="form.name"></el-input>
					</el-form-item>
					<el-form-item label="文件">
						<upload style="margin-top: 10px;" :value="form.file" :formCreateInject="true" />
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>


</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		mixins: [modalMixins],
		props: {

		},
		data() {
			return {
				modal_width: 500,
				modal_height: 500,
				modal_title: '新增产品文档',
				options: [],
				form: {
					type: '',
					name:'',
					file: []
				}
			}
		},
		created() {
			this.getOptions()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			getOptions() {
				let options = []
				let getEmun = window.systemMethods.getEmun('goodsfile')
				getEmun.forEach((item) => {
					options.push({
						value: item.label,
						label: item.label
					})
				})
				this.options = options
				console.log(options)
			},
			modal_init() {
				this.form = {
					type: '',
					name:'',
					file: []
				}
			},
			modal_hide() {
				this.form = {
					type: '',
					name:'',
					file: []
				}
				this.$emit('modalhide')
			},
			change(e){
				if(e!='实拍实测'){
					this.form.name = e
				}else{
					this.form.name = ''
				}				
				//console.log(e)
			},
			submit() {
				if (!this.form.type || this.form.file.length == 0) {
					this.$message.error('请完善信息')
				} else {
					this.$emit('submit', this.form)
					this.modal_cancel()
				}
			}
		},
		components: {
			upload
		}
	}
</script>